import type { RuntimeTheme } from './types'

const DEFAULT_RUNTIME_THEME: RuntimeTheme = {
  id: 'default',
  key: 'default',
  name: 'Emporion Default',
  mode: 'light',
  status: 'published',
  isActive: true,
  tokens: {
    colors: {
      primary: '#10b981',
      background: '#f8fafc',
      surface: '#ffffff',
      text: '#0f172a',
      muted: '#64748b',
      border: '#e2e8f0',
      accent: '#14b8a6',
    },
    typography: {
      fontFamilyBase: '"Inter", "Segoe UI", sans-serif',
      fontFamilyHeading: '"Inter", "Segoe UI", sans-serif',
      fontScaleBase: 1,
    },
    radius: {
      sm: '0.375rem',
      md: '0.5rem',
      lg: '1rem',
      xl: '1.5rem',
    },
    spacing: {
      xs: '0.25rem',
      sm: '0.5rem',
      md: '1rem',
      lg: '1.5rem',
      xl: '2rem',
    },
  },
}

/**
 * Returns immutable fallback runtime theme used when API/cache is unavailable.
 */
export const getDefaultRuntimeTheme = () => DEFAULT_RUNTIME_THEME
